<script>
import compoment from '@/components/draggable/CustomComponents/Radio/DSimpleRadioPreview'
export default {
  name: 'DAllowPostPreview',
  extends: compoment
}
</script>
